import { Route } from '@angular/router';
import {
  chooseWebsiteGuard,
  ChooseWebsitePageComponent,
  websiteGuard,
  loginSettingsGuard,
} from '@lyceo/homi/login/feature-main';
import { NotFoundPageComponent } from '@lyceo/shared/not-found/feature-main';
import { HomePageComponent } from '@lyceo/homi/home/feature-main';
import { LoginPageComponent } from '@lyceo/homi/login/feature-main';
import { runInSerialGuard } from '@lyceo/shared/util';
import { authGuard, loginGuard } from '@lyceo/shared/auth/feature-main';
import { DashboardComponent } from '@lyceo/homi/dashboard/feature-main';
import { ttFeatureFlagsGuard } from '@techniek-team/feature-flags';
import { FeatureFlag } from '@lyceo/shared/util-models';
import { personIdLoadedGuard } from '@lyceo/homi/user/feature-permissions';
import { NoAccessPageComponent } from '@lyceo/homi/user/feature-permissions';
import { noRoleGuard, roleGuard } from '@lyceo/shared/permissions/feature-main';

export const appRoutes: Route[] = [
  {
    path: '',
    canActivate: [runInSerialGuard([websiteGuard(), loginSettingsGuard()])],
    children: [
      {
        path: '',
        component: DashboardComponent,
        canActivate: [
          runInSerialGuard([
            authGuard(),
            roleGuard(['/no-access'], ['ROLE_USER']),
            personIdLoadedGuard(),
          ]),
        ],
        children: [
          {
            path: 'home',
            component: HomePageComponent,
          },
          {
            path: 'pupils',
            loadChildren: () =>
              import('@lyceo/homi/pupils/feature-main').then(
                (m) => m.featureRoutes,
              ),
          },
          {
            path: 'settings',
            loadChildren: () =>
              import('@lyceo/homi/settings/feature-main').then(
                (m) => m.featureRoutes,
              ),
          },
          {
            path: 'flashcards',
            canActivate: [
              ttFeatureFlagsGuard(FeatureFlag.FLASHCARDS, ['/home']),
            ],
            loadChildren: () =>
              import('@lyceo/shared/flashcards/feature-main').then(
                (m) => m.featureMainRoutes,
              ),
          },
          {
            path: '',
            redirectTo: 'home',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'no-access',
        component: NoAccessPageComponent,
        canActivate: [
          runInSerialGuard([
            authGuard(),
            noRoleGuard(['/home'], ['ROLE_USER']),
          ]),
        ],
      },
      {
        path: 'login',
        component: LoginPageComponent,
        canActivate: [runInSerialGuard([websiteGuard(), loginGuard()])],
      },
    ],
  },
  {
    path: 'website',
    component: ChooseWebsitePageComponent,
    canActivate: [chooseWebsiteGuard()],
  },
  {
    path: '**',
    component: NotFoundPageComponent,
  },
];
